import type { FilterProps } from '@/infra/type-utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { action } from 'mobx'
import { MoneyCell } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/MoneyCell'

export interface MoneyCellContainerProps<
  M,
  K extends keyof FilterProps<M, number | null>,
> {
  model: M
  field: K
  editable: boolean
  children: number
  testId?: string
  error?: string
}

export const MoneyCellContainer = observer(function MoneyCellContainer<
  M,
  K extends keyof FilterProps<M, number | null>,
>({
  editable,
  model,
  field,
  children,
  testId,
  error,
}: MoneyCellContainerProps<M, K>) {
  const onChange = useMemo(
    () =>
      action((value: number | null) => {
        model[field] = (value ?? undefined) as M[K]
      }),
    [model, field],
  )

  return (
    <MoneyCell
      editable={editable}
      value={(model[field] ?? null) as number | null}
      onChange={onChange}
      error={error}
      testId={testId}
    >
      {children}
    </MoneyCell>
  )
})
